//@ts-nocheck

//@ts-nocheck
import { CONFIG } from '../config.ts'

// Form submission handler
document.addEventListener('DOMContentLoaded', () => {
  const form = document.getElementById('forgot-password-form');

  if (form) {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();

      const emailOrUsername = document.getElementById('emailOrUsername').value.trim();

      if (!emailOrUsername) {
        alert('Please enter your email or username');
        return;
      }

      const submitButton = form.querySelector('button[type="submit"]');
      const originalButtonText = submitButton.textContent;
      submitButton.disabled = true;
      submitButton.textContent = 'Sending...';

      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      const isEmail = emailPattern.test(emailOrUsername);

      const requestBody = {};

      if (isEmail) {
        requestBody.Email = emailOrUsername.toLowerCase().trim();
      } else {
        requestBody.UserName = emailOrUsername.trim();
      }

      try {
        const response = await fetch(`${CONFIG.API_URL}/auth/forgot-password`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(requestBody)
        });

        const data = await response.json();

        if (!response.ok) {
          throw new Error(data.message || 'Something went wrong');
        }

        alert('If this account exists you will receive a reset link, please check your inbox.');
        window.location.href = '/src/client/pages/login.html';

      } catch (error) {
        console.error('Forgot password error:', error);
        if (error.message.includes('Failed to fetch') || error.message.includes('NetworkError')) {
          alert('Cannot connect to server. Please try again later.');
        } else {
          alert(error.message || 'Something went wrong. Please try again.');
        }
        submitButton.disabled = false;
        submitButton.textContent = originalButtonText;
      }
    });
  }
});